import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Label, Input, FormFeedback, Table } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"

class EnviarMail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            empresa: null,
            canal: null,
            ltp: null,
            lte: null,
            datos: [],
            newEmail: ""
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    resetState() {
        this.setState({
            empresa: null,
            canal: null,
            ltp: null,
            lte: null,
            emails: [],
            newEmail: ""
        })
    }
    setSelects(data) {
        data.emails = data.emails.map(x => ({
            razon: x.razon,
            email: x.email,
            checked: false,
        }));
        this.setState({
            solicitud: data.pk,
            proyecto_codigo: data.codigo,
            empresa: data.empresa_id,
            canal: data.canal_id,
            ltp: data.ltp_id,
            lte: data.lte_id,
            emails: data.emails,
        });
    }

    handleClick(i) {
        var emails = this.state.emails;
        emails[i].checked = !emails[i].checked;
        this.setState({ emails: emails });
    }

    AddNewMail(e) {
        e.preventDefault();
        if (this.state.newEmail != "") {
            var emails = this.state.emails;
            emails.push({
                razon: "--",
                email: this.state.newEmail,
                checked: true,
            });
            this.setState({ emails: emails, newEmail: "" });
        }
    }

    render() {
        var atr = [];
        if (this.state.emails) {
            for (var i = 0; i < this.state.emails.length; i++) {
                let p = i;
                let rowN = i.toString();
                let row = this.state.emails[i];
                atr.push(
                    <tr key={p}>
                        <td>
                            <input readOnly={true} onClick={(value) => this.handleClick(p)} type={"checkbox"} checked={row.checked} />
                        </td>
                        <td>
                            {row.razon}
                        </td>
                        <td>
                            <input readOnly={true} className={"d-none"} disabled={!row.checked} name={"email[" + p + "]"} value={row.email} />
                            {row.email}
                        </td>
                    </tr>
                );
            }
        }

        return (
            <ParadigmaModal
                getUrl={api.proyectos.enviodemails.enviarmail}
                postUrl={api.proyectos.enviodemails.enviarmail}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                successMessage={"El Informe ha sido enviado con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Enviar Informe al Cliente"}
                buttonTitle={"Enviar Informe al Cliente"}
                buttonIcon={"fa fa-envelope fa-lg"}
                notAllowedMessage={"La Informe no puede ser enviado porque todavía no se completaron todos los datos necesarios."}
                
                saveButton={true}
                saveButtonLabel={"Enviar"}
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.resetState()}
                className={"ui-modal-dialog ui-modal-lg"}
            >
                <div className="ui-form">
                    <div className="ui-section-grid">
                        <section className="ui-section-block ui-section-span-2">
                            <p className="ui-section-label">Datos del informe</p>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Código</Label>
                                    <ParadigmaAsyncSeeker pkField={"codigo"} nombreField={"cod"} fieldName={""} url={api.proyectos.solicitudes.selectcodigo} value={this.state.proyecto_codigo} disabled={true} />
                                    <FormFeedback />
                                </div>
                            </div>
                            <div className="ui-row-1">
                                <div className="ui-field">
                                    <Label>Proyecto</Label>
                                    <ParadigmaAsyncSeeker fieldName={"solicitud_id"} url={api.proyectos.solicitudes.select} value={this.state.solicitud} disabled={true} />
                                    <FormFeedback />
                                </div>
                            </div>
                        </section>

                        <section className="ui-section-block ui-section-span-2">
                            <p className="ui-section-label">Destinatarios</p>
                            <Table className="ui-table table-sm">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Razón</th>
                                        <th>Email</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {atr}
                                </tbody>
                            </Table>
                        </section>

                        <section className="ui-section-block ui-section-span-2">
                            <p className="ui-section-label">Agregar destinatario</p>
                            <div className="ui-row-action">
                                <div className="ui-field">
                                    <Label>Email</Label>
                                    <Input value={this.state.newEmail} onChange={(e) => this.setState({ newEmail: e.target.value })} />
                                </div>
                                <button onClick={(e) => this.AddNewMail(e)} className={"btn btn-success"} style={{ borderRadius: "8px" }}>
                                    <i className="fa fa-plus"></i>
                                </button>
                            </div>
                        </section>
                    </div>
                </div>

            </ParadigmaModal>
        );
    }
}

export default EnviarMail;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento6/EnviarMail.js